import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Container,
  Alert,
  CircularProgress
} from '@mui/material';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';

const PasswordReset: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setError('メールアドレスを入力してください');
      return;
    }

    setLoading(true);
    setError('');
    
    try {
      await axios.post(`${config.API_BASE_URL}/auth/request-password-reset`, { email });
      setSuccess(true);
    } catch (err: any) {
      setError(err.response?.data?.message || 'パスワードリセットリクエストの送信に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, mb: 4 }}>
        <Paper sx={{ p: 4 }}>
          <Typography variant="h5" component="h1" gutterBottom align="center">
            パスワードリセット
          </Typography>
          
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          
          {success ? (
            <Box>
              <Alert severity="success" sx={{ mb: 2 }}>
                パスワードリセット手順を記載したメールを送信しました。メールをご確認ください。
              </Alert>
              <Box sx={{ mt: 2, textAlign: 'center' }}>
                <Link to="/login" style={{ textDecoration: 'none' }}>
                  <Button variant="text" color="primary">
                    ログインページに戻る
                  </Button>
                </Link>
              </Box>
            </Box>
          ) : (
            <form onSubmit={handleSubmit}>
              <Typography variant="body2" color="textSecondary" paragraph>
                アカウントに登録されているメールアドレスを入力してください。パスワードリセット用のリンクをメールで送信します。
              </Typography>
              
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="メールアドレス"
                name="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                sx={{ mt: 3, mb: 2 }}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'リセットリンクを送信'}
              </Button>
              
              <Box sx={{ mt: 2, textAlign: 'center' }}>
                <Link to="/login" style={{ textDecoration: 'none' }}>
                  <Button variant="text" color="primary">
                    ログインページに戻る
                  </Button>
                </Link>
              </Box>
            </form>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default PasswordReset; 